"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 20px 24px 24px;\n  width: 100%;\n  border-radius: 18px;\n  cursor: pointer;\n  transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;\n  box-sizing: border-box;\n  ", ";\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: ", ";\n  }\n"], ["\n  position: relative;\n  padding: 20px 24px 24px;\n  width: 100%;\n  border-radius: 18px;\n  cursor: pointer;\n  transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;\n  box-sizing: border-box;\n  ", ";\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: ", ";\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"], ["\n  ", ";\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _buoyTheme = require("buoy-theme");

var _buoyText = require("buoy-text");

var _Cross = require("../images/Cross");

var _Cross2 = _interopRequireDefault(_Cross);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactPose = require("react-pose");

var _reactPose2 = _interopRequireDefault(_reactPose);

var _popmotion = require("popmotion");

var _flubber = require("flubber");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Section = _styledComponents2.default.div.withConfig({
  displayName: "ExpandableSection__Section",
  componentId: "w6ugqo-0"
})(_templateObject, function (props) {
  return (0, _buoyTheme.responsive)("box-shadow", props.noShadow ? "none" : _buoyTheme.constants.boxShadow(props), props.noShadow ? "none" : _buoyTheme.constants.boxShadow(props), _buoyTheme.constants.boxShadow(props), _buoyTheme.constants.boxShadow(props), _buoyTheme.constants.boxShadow(props));
}, function (props) {
  return props.noShadow ? _buoyTheme.constants.boxShadow(props) : _buoyTheme.constants.boxShadowHover(props);
});

var TitleTile = _styledComponents2.default.div.withConfig({
  displayName: "ExpandableSection__TitleTile",
  componentId: "w6ugqo-1"
})(_templateObject2);
var TitleTileH3 = (0, _styledComponents2.default)(_buoyText.HeadingThree).withConfig({
  displayName: "ExpandableSection__TitleTileH3",
  componentId: "w6ugqo-2"
})(_templateObject3, (0, _buoyTheme.responsive)("margin-right", "40px", "40px", "20px", "20px", "40px"));

var HiddenContentAccordion = _reactPose2.default.div({
  closed: { height: 0, opacity: 0 },
  open: { height: "auto", opacity: 1 }
});

var HiddenContent = (0, _styledComponents2.default)(HiddenContentAccordion).withConfig({
  displayName: "ExpandableSection__HiddenContent",
  componentId: "w6ugqo-3"
})(_templateObject4);

var Padding = _styledComponents2.default.div.withConfig({
  displayName: "ExpandableSection__Padding",
  componentId: "w6ugqo-4"
})(_templateObject3, (0, _buoyTheme.responsive)("padding-top", "24px", "24px", "48px", "48px", "48px"));

var morphTransition = function morphTransition(_ref) {
  var from = _ref.from,
      to = _ref.to;
  return (0, _popmotion.tween)({
    from: 0,
    to: 1
  }).pipe((0, _flubber.interpolate)(from, to));
};

var Icon = _reactPose2.default.path({
  plus: {
    d: 'M11 11v-11h1v11h11v1h-11v11h-1v-11h-11v-1h11z',
    transition: morphTransition
  },
  minus: {
    d: 'M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z',
    transition: morphTransition
  }
});

var ExpandableSection = function ExpandableSection(_ref2) {
  var children = _ref2.children,
      title = _ref2.title,
      onClick = _ref2.onClick,
      expanded = _ref2.expanded,
      noShadow = _ref2.noShadow,
      className = _ref2.className;
  return _react2.default.createElement(
    Section,
    { onClick: onClick, noShadow: noShadow, className: className },
    _react2.default.createElement(
      TitleTile,
      null,
      _react2.default.createElement(
        TitleTileH3,
        { margin: "0 40px 0 0" },
        title
      ),
      _react2.default.createElement(
        "svg",
        { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg",
          fill: "#939393" },
        _react2.default.createElement(Icon, { pose: expanded ? "minus" : "plus" })
      )
    ),
    _react2.default.createElement(
      HiddenContent,
      { pose: expanded ? "open" : "closed" },
      _react2.default.createElement(
        Padding,
        null,
        children
      )
    )
  );
};

var ExpandableSectionContainer = function (_Component) {
  _inherits(ExpandableSectionContainer, _Component);

  function ExpandableSectionContainer() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, ExpandableSectionContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = ExpandableSectionContainer.__proto__ || Object.getPrototypeOf(ExpandableSectionContainer)).call.apply(_ref3, [this].concat(args))), _this), _this.state = { expanded: false }, _this.onSectionClick = function () {
      _this.state.expanded ? _this.setState({ expanded: false }) : _this.setState({ expanded: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ExpandableSectionContainer, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          title = _props.title,
          children = _props.children,
          className = _props.className;


      if (!children || !title) return null;

      return _react2.default.createElement(
        ExpandableSection,
        {
          title: title,
          onClick: this.onSectionClick,
          expanded: this.state.expanded,
          noShadow: this.props.noShadow,
          className: className
        },
        children
      );
    }
  }]);

  return ExpandableSectionContainer;
}(_react.Component);

ExpandableSectionContainer.propTypes = {
  title: _propTypes2.default.string.isRequired
};

ExpandableSectionContainer.defaultProps = {
  title: "Is my health information safe with Buoy?",
  noShadow: false
};

exports.default = ExpandableSectionContainer;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-expandable-container/dist/components/ExpandableSection.js
// module id = 405
// module chunks = 168707334958949